import React from 'react'
import Banner from '../Components/banner'
import CoinsTable from '../Components/coinsTable'

const Homepage = () => {
  return (
    <div>
      <Banner />
      <CoinsTable />
    </div>
  )
}

export default Homepage
